module.exports = __webpack_public_path__ + "h5/img/vip4.40eb50e6.png";